import React, { useContext } from 'react';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import UpdateDetailsModal from './component/UpdateDetailsModal';
import * as actions from '../../../action';

function DetailsBasicsContainer({
  newTaxRevenuesId,
  calculationsId,
  detailsList,
}) {
  const setModal = useContext(ModalContext);

  const handleUpdateDetails = (detailsId, val) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateDetailsModal
          newTaxRevenuesId={newTaxRevenuesId}
          calculationsId={calculationsId}
          id={_.get(detailsList, 'id')}
          detailsId={detailsId}
          updateList={val}
        />
      ),
      title: 'Update Details',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="row mb-1 pb-1">
      <div className="col-12 mt-5">
        <table className="transaction-table table table-bordered table-sm table-striped table-hover">
          <thead>
            <tr>
              <td className="text-left">Amount</td>
              <td className="text-left">Rate</td>
              <td className="text-right">Actions</td>
            </tr>
          </thead>
          <tbody>
            {detailsList && detailsList.length <= 0 && (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
            {detailsList &&
              detailsList.map(item => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.amount_human')}
                  </td>
                  <td className="text-left">
                    {_.get(item, 'attributes.rate_human')}
                  </td>
                  <td className="text-right">
                    <button
                      onClick={handleUpdateDetails(
                        _.get(item, 'id'),
                        _.get(item, 'attributes')
                      )}
                      type="button"
                      className="btn-blank"
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

DetailsBasicsContainer.propTypes = {
  calculationsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  detailsList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DetailsBasicsContainer);
